/**
 * Luli For Babies — botão de compartilhar (réplica do site Lovable).
 * Usa o compartilhamento nativo no celular e, no desktop, copia o link
 * e mostra o aviso "Link copiado!".
 */
class LuliShare extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.feedback = this.querySelector('[ref="feedback"]');
    this.button?.addEventListener('click', () => this.share());
  }

  async share() {
    const url = window.location.href;
    const title = this.dataset.title || document.title;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error.name === 'AbortError') return; // usuário cancelou
      }
    }

    if (await this.copy(url)) this.showFeedback();
  }

  /**
   * Copia o link. A Clipboard API falha em contexto não seguro, sem foco ou em
   * navegadores antigos — nesses casos cai no método legado, para o cliente
   * nunca clicar e não receber retorno nenhum.
   * @param {string} url
   * @returns {Promise<boolean>} se alguma das tentativas funcionou
   */
  async copy(url) {
    try {
      await navigator.clipboard.writeText(url);
      return true;
    } catch (error) {
      /* tenta o método legado abaixo */
    }

    try {
      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      const ok = document.execCommand('copy');
      field.remove();
      return ok;
    } catch (error) {
      return false;
    }
  }

  showFeedback() {
    if (!this.feedback) return;
    this.feedback.hidden = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.feedback.hidden = true;
    }, 2000);
  }
}

if (!customElements.get('luli-share')) {
  customElements.define('luli-share', LuliShare);
}
